/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import './changePassword.scss';
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string, InferType, ref } from "yup";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { nonSSOLogin, selectNonSSOLoginDetails } from './nonSSOLoginSlice';
import { chgpwd, selectchgpwdDetails } from './changePasswordSlice';
import jwt_decode from "jwt-decode";
import { useDispatch, useSelector } from 'react-redux';
import CountDownTimer from './otpCountDownTimer';
import { genOTPandSaveUser, selectOTPandUserDetails } from './genOTPandSaveUserSlice';
import DotGlobe from "./DotGlobe";
import { OtpInput } from "./OtpInput";

const changePwdSchema = object({
    currentPassword: string()
        .required("Please enter the Password")
        .matches(
            /(?=.*?[A-Z])/,
            "Please enter atleast one Uppercase"
        )
        .matches(
            /(?=.*?[a-z])/,
            "Please enter atleast one Lowercase"
        )
        .matches(
            /(?=.*?[0-9])/,
            "Please enter atleast one digit"
        )
        .matches(
            /(?=.*?[#?!@$%^&*-])/,
            "Please enter atleast one Special Character"
        )
        .matches(
            /.{8,}/,
            "Please enter minumum 8 characters"
        ),
    newPassword: string()
        .required("Please enter the Password")
        .matches(
            /(?=.*?[A-Z])/,
            "Please enter atleast one Uppercase"
        )
        .matches(
            /(?=.*?[a-z])/,
            "Please enter atleast one Lowercase"
        )
        .matches(
            /(?=.*?[0-9])/,
            "Please enter atleast one digit"
        )
        .matches(
            /(?=.*?[#?!@$%^&*-])/,
            "Please enter atleast one Special Character"
        )
        .matches(
            /.{8,}/,
            "Please enter minumum 8 characters"
        ),
    confirmPassword: string()
        .required("Please enter the Password")
        .oneOf([ref("newPassword")], "Confirm Password does not match"),
});


const changePwdOTPSchema = object({
    otp: string()
        .required("Please enter the OTP")
        .min(6, "OTP minimum digit is 6")
        .max(6, "OTP maximum digit is 6"),
});

type changePwdProps = InferType<typeof changePwdSchema>;
type changePwdOTPProps = InferType<typeof changePwdOTPSchema>;

const calcStrength = (v: string) => {
    let s = 0;
    if (v.length >= 8) s++;
    if (/[A-Z]/.test(v) && /[a-z]/.test(v)) s++;
    if (/[0-9]/.test(v)) s++;
    if (/[#?!@$%^&*-]/.test(v)) s++;
    return s;
};

export function ChangePassword() {

    const dispatch = useDispatch();
    const [password, setPassword] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const { nonSSOStatus, nonSSOState, nonSSOReqType } = useSelector(selectNonSSOLoginDetails);
    const [otp, setOtp] = useState('');
    const [pwdError, setPwdError] = useState('');
    const [showCur, setShowCur] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [strength, setStrength] = useState(0);
    const { chgpwdState, chgpwdStatus } = useSelector(selectchgpwdDetails);
    let decodedToken: any = null;
    const { otpstate, otpstatus, regrequestType } = useSelector(selectOTPandUserDetails);
    const { register: changePwdRegister, handleSubmit: changePwdHandle, formState: { errors: changePwdErrors }, reset: changePwdchange } =
        useForm<changePwdProps>({
            resolver: yupResolver(changePwdSchema),
        });

    const { register: changePwdOTPRegister, handleSubmit: changePwdOTPHandle, formState: { errors: changePwdOTPErrors }, reset: changePwdOTPchange, setValue: changePwdOTPSetValue } =
        useForm<changePwdOTPProps>({
            resolver: yupResolver(changePwdOTPSchema),
        });

    // Register OTP field so the segmented OtpInput can drive it via setValue.
    useEffect(() => {
        changePwdOTPRegister("otp");
    }, [changePwdOTPRegister]);

    const handleOtpChange = (value: string) => {
        setOtp(value);
        changePwdOTPSetValue("otp", value, { shouldValidate: false });
    };

    function handleChangePwdSubmit() {
        if(currentPassword === password)
        {
            setPwdError("Current Password and New password should be different");
            return;
        }
        else
        {
         setPwdError("");   
        }

        const token: any = localStorage.getItem("AccessToken-NonSSO");
        if (token) {
            decodedToken = jwt_decode(token);
        }
        const data = {
            "input": {
                "username": decodedToken?.upn,
                "password": currentPassword,
                "otp": "",
                "subAction": ""
            },
            "nonSSOReqType": {
                "type": "ChgPwd"
            }
        }
        dispatch<any>(nonSSOLogin(data));
    }

    function handleChangePwdOtp() {
        const token: any = localStorage.getItem("AccessToken-NonSSO");
        if (token) {
            decodedToken = jwt_decode(token);
        }
        const data = {
            "personalEmailAddress": decodedToken?.upn,
            "currentPassword": currentPassword,
            "NewPassword": password,
            "subAction": "validateOTPandSave",
            "otp": otp,
            "action":""
        }
        dispatch<any>(chgpwd(data));
    }

    function handleResendOTP() {
        const token: any = localStorage.getItem("AccessToken-NonSSO");
        if (token) {
            decodedToken = jwt_decode(token);
        }

        const data = {
            "input": {
              "request": {
                "action": "ValidateNewUser",
                "personalEmailAddress": decodedToken?.upn,
                "phoneNumber": "",
                "subAction": ""
              }
            },
            "requestType": {
              "type": "changePwd"
            }
          }
          dispatch<any>(genOTPandSaveUser(data));
    }

    function refreshPage() {
        window.location.reload();
      }   

    const BackArrow = (
        <svg viewBox="0 0 24 24" fill="none">
            <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    return (
        <div className="landingPage">
            <aside className="brandPanel" aria-hidden="true">
                <div className="brandGrid" />
                <DotGlobe className="brandGlobe" size={520} variant="bright" />
                <div className="brandPanelContent">
                    <h2 className="brandTitle">TTEC Connect</h2>
                    <p className="brandTagline">
                        Everything you need to get started — your onboarding hub, in one place.
                    </p>
                </div>
            </aside>
            <div className="loginContainer">
                <form className="Auth-form" onSubmit={changePwdHandle(handleChangePwdSubmit)}>
                    {(nonSSOStatus !== "fulfilled" && nonSSOState !== "success" && nonSSOReqType === "") &&
                        <div>
                            <div className="eyebrow">Account settings</div>
                            <h1 className="authH1">Change password</h1>
                            <p className="sub">You'll confirm the change with a one-time code.</p>
                            {nonSSOState === 'failed' && <div className="alert err">Current Password does not match</div>}

                            <div className="field hasIcon">
                                <input
                                    id="chCur"
                                    type={showCur ? "text" : "password"}
                                    placeholder=" "
                                    {...changePwdRegister("currentPassword")}
                                    onKeyUp={(event) => setCurrentPassword(event.currentTarget.value)}
                                />
                                <label htmlFor="chCur">Current password <span className="req">*</span></label>
                                <button type="button" className="icon" aria-label="Show password" onClick={() => setShowCur(s => !s)}>
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" stroke="currentColor" strokeWidth="2" />
                                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                                    </svg>
                                </button>
                            </div>
                            {changePwdErrors?.currentPassword && <p className="frmErrors mt-2">{changePwdErrors?.currentPassword?.message}</p>}

                            <div className="field hasIcon">
                                <input
                                    id="chNew"
                                    type={showNew ? "text" : "password"}
                                    placeholder=" "
                                    {...changePwdRegister("newPassword")}
                                    onKeyUp={(event) => { setPassword(event.currentTarget.value); setStrength(calcStrength(event.currentTarget.value)); }}
                                />
                                <label htmlFor="chNew">New password <span className="req">*</span></label>
                                <button type="button" className="icon" aria-label="Show password" onClick={() => setShowNew(s => !s)}>
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" stroke="currentColor" strokeWidth="2" />
                                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                                    </svg>
                                </button>
                            </div>
                            <div className="meter">
                                {[1, 2, 3, 4].map((n) => (
                                    <i key={n} className={n <= strength ? "on" + strength : ""} />
                                ))}
                            </div>
                            <div className="meter-label">
                                <span>Must differ from current password</span>
                                <span>{["", "Weak", "Fair", "Good", "Strong"][strength]}</span>
                            </div>
                            {(changePwdErrors?.newPassword || pwdError !== '') && <p className="frmErrors mt-2">{pwdError !== '' ? pwdError : changePwdErrors?.newPassword?.message}</p>}

                            <div className="field">
                                <input
                                    id="chConf"
                                    type="password"
                                    placeholder=" "
                                    {...changePwdRegister("confirmPassword")}
                                />
                                <label htmlFor="chConf">Re-enter new password <span className="req">*</span></label>
                            </div>
                            <p className="frmErrors mt-2">{changePwdErrors?.confirmPassword && changePwdErrors?.confirmPassword?.message}</p>

                            <button type="submit" className="btn btn-primary">Send code</button>
                        </div>
                    }
                </form>

                <form className="Auth-form" onSubmit={changePwdOTPHandle(handleChangePwdOtp)}>
                    {(nonSSOStatus === "success" && nonSSOState === "fulfilled" && (nonSSOReqType === "login" || nonSSOReqType === "ChgPwd")) && (chgpwdState !== "success" && chgpwdState !== "fulfilled") &&
                        <div>
                            <h1 className="authH1">One Time Password (OTP)</h1>
                            <div className="alert ok">A One Time Password (OTP) has been sent to your mobile number and email address.</div>

                            <OtpInput value={otp} onChange={handleOtpChange} />

                            <p className="frmErrors mt-2"> {(chgpwdState === 'failed' && 'Please enter correct OTP') || (changePwdOTPErrors?.otp && changePwdOTPErrors?.otp?.message)}</p>
                            {otpstate !== 'pending' &&
                                <div className="timerRow"><CountDownTimer hours={0} minutes={10} seconds={0o0} /></div>}
                            {otpstate !== 'pending' &&
                                <div className="resendRow">Didn't receive the code? &nbsp;<Link to="" onClick={handleResendOTP}>Resend Code</Link></div>}
                            {otpstate === 'pending' &&
                                <div className="resendRow">Resending Code... &nbsp; <div className="counter"></div></div>}
                            <button type="submit" className="btn btn-primary">Change Password</button>
                        </div>
                    }
                    {chgpwdState === "fulfilled" && chgpwdStatus === "success" &&
                        <div className="center">
                            <div className="successMark">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h1 className="authH1">Password changed</h1>
                            <div className="alert ok">Your password was changed successfully</div>
                            <Link to="" className="backlink" onClick={refreshPage}>{BackArrow}Back to Profile</Link>
                        </div>
                    }
                </form>
            </div>
        </div>
    )
}
